const SCRIPT_ID = 'sf-google-maps-script';
const CALLBACK_NAME = '__sfGoogleMapsReady';

let loadPromise = null;

/**
 * Loads the Google Maps JS API (places library) exactly once and resolves
 * with the `places` library namespace. `loading=async` only finishes
 * initializing `google.maps.importLibrary` once its paired `callback` param
 * fires — a plain <script onload> handler runs too early to see it.
 */
export function loadGoogleMapsPlaces() {
  if (loadPromise) return loadPromise;

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    return Promise.reject(new Error('REACT_APP_GOOGLE_MAPS_API_KEY is not set'));
  }

  loadPromise = new Promise((resolve, reject) => {
    const importPlaces = () => window.google.maps.importLibrary('places').then(resolve, reject);

    if (window.google?.maps?.importLibrary) {
      importPlaces();
      return;
    }

    if (document.getElementById(SCRIPT_ID)) {
      // Script tag already injected by a previous call; CALLBACK_NAME below
      // still fires once it finishes loading, so just wait for that.
      window[CALLBACK_NAME] = importPlaces;
      return;
    }

    window[CALLBACK_NAME] = importPlaces;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&v=weekly&loading=async&callback=${CALLBACK_NAME}`;
    script.async = true;
    script.onerror = () => reject(new Error('Failed to load Google Maps script'));
    document.head.appendChild(script);
  });

  return loadPromise;
}
